// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xOtG","left":"styles_left__U1S4i"};